import { connect } from 'react-redux';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { setLoading, setClipboardText, refreshTickets } from '../actions';
import * as extract from 'extractFromState';
import { updateOwnAvailability } from '../actions/creatorsSync';
import { compose } from 'redux';
import ExpertPortalComponent from '../components/ExpertPortalComponent/ExpertPortalComponent';
import { getOwnAvailability, getOwnExpert } from '../selectors/experts';
import { SELECT_INBOX_TAB } from 'actions/types';

import { handleConversationLoading } from 'actions/conversationActions';

const mapStateToProps = (state) => ({
  general: (state.ui && state.ui.tools && state.ui.tools.general) || {},
  selectedInboxTab: state.ui && state.ui.messages && state.ui.messages.selectedInboxTab,
  queueLength:
    state.ui.messages.selectedInboxTab === 'nominated'
      ? state.tickets.nominatedTickets.allTickets.length
      : state.tickets.assignedTickets.allTickets.length,
  errors: state.errors,
  user: state.user,
  availability: getOwnAvailability(state),
  ownExpert: getOwnExpert(state),
  isAdmin: state.user.isAdmin,
  liveQueryStarted: state.liveQueryStarted,
  tickets: state.tickets,
  unreadNominatedTicketIds: state.unreadNominatedTicketIds,
  isSpecialistLite: extract.isSpecialistLite(state),
  selectedTicketTaken: extract.isSelectedTicketTaken(state),
  centerPaneInfoPanelActive: extract.extractCenterPaneInfoPanelActiveFromState(state),
  selectedSimplrAccountId: extract.getSimplrAccountIdOfSelectedTicket(state),
  isExpertDashboardOpened: extract.getIsExpertDashboardOpened(state),
  isCommerceWizardActive: extract.isCommerceWizardActive(state),
});

const mapDispatchToProps = (dispatch) => ({
  loading: (isLoading, component) => dispatch(setLoading(isLoading, component)),
  updateOwnAvailability: compose(dispatch, updateOwnAvailability),
  onLoad: (liveQueryStarted, searchString) => dispatch(handleConversationLoading(liveQueryStarted, searchString)),
  selectInboxTabWithoutLoadingTickets: (tabName) => dispatch({ type: SELECT_INBOX_TAB, tabName }),
  setClipboardText: (text) => dispatch(setClipboardText(text)),
  refreshTickets: () => dispatch(refreshTickets()),
});

const ConditionalExpertPortal = (props) =>
  // only load expert portal when data dependencies are populated
  props.user.id && (props.isAdmin || props.ownExpert) ? (
    <ExpertPortalComponent {...props} />
  ) : (
    // TODO show loading image
    <div />
  );

const ExpertPortalContainer = connect(mapStateToProps, mapDispatchToProps)(ConditionalExpertPortal);

export default withRouter(ExpertPortalContainer);
